module.exports = {"652871400":"开发区乡级单位"}


//////////////////
// WEBPACK FOOTER
// ./src/town/652871.json
// module id = 3091
// module chunks = 0